<template>
  <div>
    <button
      v-if="productos.length"
      class="btn-flotante-carrito"
      @click="abrirCarrito"
    >
      <i class="mdi mdi-cart-outline"></i>
      <span class="badge-carrito">{{ productos.length }}</span>
    </button>
    <transition name="slide-cart">
      <div v-if="visible" class="carrito-drawer">
        <div class="carrito-header">
          <span>Tu Carrito</span>
          <button class="cerrar" @click="cerrarCarrito">
            <i class="mdi mdi-close"></i>
          </button>
        </div>
        <div class="carrito-contenido" v-if="productos.length">
          <!-- AQUÍ USAS transition-group SOLO PARA LA LISTA -->
          <transition-group name="fade-list" tag="div">
            <div
              v-for="(prod, idx) in productos"
              :key="
                prod.id +
                '-' +
                prod.talla +
                '-' +
                prod.tipo +
                '-' +
                (prod.imagenKey || '')
              "
              class="carrito-item"
            >
              <img :src="prod.imagen" alt="" class="carrito-img" />
              <div>
                <strong>{{ prod.nombre }}</strong
                ><br />
                <span style="font-size: 13px">
                  <em>Talla: {{ prod.talla }}</em
                  ><br />
                  <em>Tipo: {{ prod.tipo }}</em>
                </span>
                <div style="font-size: 13px">Cantidad: {{ prod.cantidad }}</div>
                <div style="font-size: 13px">
                  Precio: $ {{ prod.precio.toLocaleString() }}
                </div>
              </div>
              <button class="eliminar" @click="eliminar(idx)">
                <i class="mdi mdi-delete"></i>
              </button>
            </div>
          </transition-group>
        </div>
        <div v-else class="carrito-vacio">Tu carrito está vacío.</div>
        <div class="carrito-footer">
          <div class="carrito-subtotal">
            <strong>Subtotal:</strong> $ {{ total.toLocaleString() }}
          </div>
          <div class="carrito-info">
            Gastos de envíos y descuentos, al final de la compra
          </div>
          <div class="carrito-actions">
            <button class="carrito-btn carrito-btn-secundario" @click="seguirComprando">
              Seguir comprando
            </button>
            <button class="carrito-btn carrito-btn-principal" @click="finalizarCompra">
              {{ esEmpleado ? "Apartar por linea" : "Finalizar compra" }}
            </button>
          </div>
        </div>
        <!-- Botón flotante del carrito -->
      </div>
    </transition>
  </div>
</template>


<script>
export default {
  name: "CarritoLateral",
  computed: {
    productos() {
      return this.$store.getters.productosCarrito;
    },
    total() {
      return this.$store.getters.totalCarrito;
    },
    visible() {
      return this.$store.getters.mostrarCarrito;
    },
    esMayorista() {
      const rol = localStorage.getItem("rol");
      return (
        rol === "mayorista" ||
        rol === "administrador" ||
        rol === "cajero" ||
        rol === "inven"
      );
    },
    esEmpleado() {
      const rol = localStorage.getItem("rol");
      return rol === "cajero" || rol === "inven" || rol === "administrador";
    },
  },
  methods: {
    abrirCarrito() {
      this.$store.commit("toggleCarrito", true);
    },
    cerrarCarrito() {
      this.$store.commit("toggleCarrito", false);
    },
    eliminar(idx) {
      const prod = this.productos[idx];
      this.$store.commit("eliminarDelCarrito", idx);
      if (this.esMayorista) {
        this.$store.commit("recalcularPreciosMayoreo", {
          id: prod.id,
          esMayorista: this.esMayorista,
          precioMayoreo: prod.precioMayoreo || prod.precio,
          precioVenta: prod.precioVenta || prod.precio,
        });
      }
    },
    seguirComprando() {
      this.$store.commit("toggleCarrito", false);
    },
    finalizarCompra() {
      this.$store.commit("toggleCarrito", false);
      this.$router.push({ name: "FinalizarCompra" });
    },
  },
};
</script>


<style scoped>
.carrito-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 370px;
  max-width: 97vw;
  height: 100dvh;
  background: #fff;
  box-shadow: -2px 0 18px 0 rgba(0, 0, 0, 0.15);
  z-index: 9001;
  display: flex;
  flex-direction: column;
}
.carrito-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 22px 16px 10px 22px;
  font-size: 1.2rem;
  font-weight: 600;
  border-bottom: 1px solid #f1f1f1;
}
.cerrar {
  background: none;
  border: none;
  font-size: 1.8rem;
  color: #333;
  cursor: pointer;
}
.carrito-contenido {
  flex: 1;
  overflow-y: auto;
  padding: 18px 14px 0 14px;
}
.carrito-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  background: #fafafa;
  margin-bottom: 14px;
  padding: 12px;
  border-radius: 12px;
  position: relative;
}
.carrito-img {
  width: 60px;
  height: 60px;
  object-fit: contain;
  border-radius: 8px;
  background: #fff;
}
.eliminar {
  background: none;
  border: none;
  color: #f03e3e;
  font-size: 1.2rem;
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
}
.carrito-footer {
  position: sticky;
  bottom: 0;
  padding: 14px 16px calc(14px + env(safe-area-inset-bottom));
  border-top: 1px solid #eee;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 0;
  box-shadow: 0 -10px 24px rgba(15, 23, 42, 0.08);
}
.carrito-subtotal {
  font-weight: bold;
  font-size: 1.1rem;
}
.carrito-info {
  font-size: 0.97rem;
  color: #222;
  margin-bottom: 4px;
}
.carrito-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}
.carrito-btn {
  color: #111;
  border: none;
  border-radius: 6px;
  min-height: 46px;
  padding: 8px 10px;
  font-size: 0.94rem;
  line-height: 1.15;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.18s, color 0.18s;
}
.carrito-btn-secundario {
  background: #f3f4f6;
}
.carrito-btn-principal {
  background: #111;
  color: #fff;
}
.carrito-btn:hover {
  background: #2c73d2;
  color: #fff;
}
.carrito-vacio {
  text-align: center;
  color: #888;
  padding: 40px 0;
  font-size: 1.12rem;
}

.slide-cart-enter-active,
.slide-cart-leave-active {
  transition: transform 0.25s cubic-bezier(0.69, 1.34, 0.72, 0.92);
}
.slide-cart-enter,
.slide-cart-leave-to {
  transform: translateX(100%);
}
.btn-flotante-carrito {
  position: fixed;
  bottom: 96px;
  right: 32px;
  background: #2c73d2;
  color: #fff;
  border: none;
  border-radius: 50%;
  box-shadow: 0 4px 16px 0 rgba(44, 115, 210, 0.09);
  width: 50px;
  height: 50px;
  font-size: 2.15rem;
  z-index: 9200;
  display: flex;

  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.18s, transform 0.14s;
  animation: flotarCarrito 0.8s cubic-bezier(0.68, -0.6, 0.32, 1.6) both;
}
.btn-flotante-carrito:hover {
  background: #1b365d;
  transform: scale(1.08);
}
.badge-carrito {
  position: absolute;
  bottom: 47px;
  right: 0px;
  background: #f03e3e;
  color: #fff;
  border-radius: 50%;
  font-size: 1rem;
  font-weight: 700;
  min-width: 22px;
  min-height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #fff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.13);
}
@keyframes flotarCarrito {
  0% {
    transform: scale(0.7) translateY(30px);
  }
  100% {
    transform: scale(1) translateY(0);
  }
}

@media (max-width: 768px) {
  .carrito-drawer {
    width: 100vw;
    max-width: 100vw;
    z-index: 12050;
  }

  .carrito-header {
    min-height: 54px;
    padding: 12px 16px;
  }

  .carrito-contenido {
    padding: 12px 14px 150px;
  }

  .carrito-footer {
    bottom: 76px;
    padding: 12px 14px;
    border-radius: 14px 14px 0 0;
  }

  .carrito-subtotal {
    font-size: 1rem;
  }

  .carrito-info {
    font-size: 0.86rem;
    line-height: 1.25;
    margin-bottom: 2px;
  }

  .carrito-actions {
    gap: 8px;
  }

  .carrito-btn {
    min-height: 44px;
    padding: 8px 6px;
    font-size: 0.9rem;
  }

  .btn-flotante-carrito {
    display: none;
  }
}
</style>
